module.exports = __webpack_public_path__ + "img/Efdot-Hat-05@2x.58949d55.jpg";